module.exports = __webpack_public_path__ + "static/media/Hippopotas_gaussian2.32a3ac9e.png";